// extracted by mini-css-extract-plugin
export default {"logo":"BrandLogo_logo__Lz10h"};